module.exports = __webpack_public_path__ + "img/2025-ford-maverick.8c996960.png";